import { Component, Inject, OnInit } from '@angular/core';
import { FhSideBarHeaderConfigModel, FhSideBarProviderService } from '@fh-client-interaction-frontends/fh-side-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { SharedEventsService, UiListModel } from '@fh-client-interaction-frontends/fh-providers';
import { RouteDataModel } from '@fh-client-interaction-frontends/route-config';
import { DefaultSettingsModel } from '../helpers/objects/default-settings/default-settings-model';
import { SharedSettingsService } from '@fh-client-interaction-frontends/fh-configurations';

@Component({
  selector: 'feature-fh-settings-generic',
  templateUrl: './fh-settings-generic.component.html',
  styleUrl: './fh-settings-generic.component.scss'
})
export class FhSettingsGenericComponent implements OnInit {
  appConfig: EnvironmentModel = new EnvironmentModel();
  loadingForm: boolean = false;
  configFiltersList: UiListModel[] = new Array<UiListModel>();
  configFilters: RouteDataModel = new RouteDataModel();
  languageList: any;
  defaultLanguage = this.appConfig.i18n.defaultLang;
  isPersonalArea = this.router.url.includes('personal-area/');
  parsedSettings: DefaultSettingsModel = new DefaultSettingsModel();

  finishLoading: boolean = false;

  constructor(
    private fhSideBarProviderService: FhSideBarProviderService,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel,
    private sharedEventsService: SharedEventsService,
    private router: Router,
    private sharedSettingsService: SharedSettingsService
  ) {
    this.appConfig = appConfigTemp;
    this.backgroundEvents();
  }

  ngOnInit() {
    this.fhSideBarProviderService.configHeaderEmitter.emit(
      new FhSideBarHeaderConfigModel({
        navigateBackButton: this.configFilters.fhSideBarConfigs?.configHeaderEmitter.navigateBackButton,
        outlet: this.isPersonalArea ? '' : this.configFilters.fhSideBarConfigs?.configHeaderEmitter.outlet,
        parentNavigation: this.configFilters.fhSideBarConfigs?.configHeaderEmitter.parentNavigation,
        parentLabel: this.configFilters.fhSideBarConfigs?.configHeaderEmitter.parentLabel
      })
    );
    this.fhSideBarProviderService.widthChangedEmitter.emit(this.configFilters.fhSideBarConfigs?.widthChangedEmitter ?? 'auto');
  }

  backgroundEvents() {
    this.activatedRoute.data.subscribe({
      next: (values) => {
        this.configFilters = values as RouteDataModel;
        this.configFiltersList = values['uiList'];
        if (this.configFilters.feature === 'settings-general') {
          this.getEnvironmentLanguages();
        }
        const localSettings = localStorage.getItem('settings');
        if (localSettings) {
          this.parsedSettings = JSON.parse(localSettings);
        }
        setTimeout(() => {
          this.finishLoading = true;
        }, 0);
      }
    });
  }

  getEnvironmentLanguages() {
    const options = this.configFiltersList.filter((item: any) => item.name === 'form')[0].formItems;
    if (options[0].formControl === 'defaultLanguage') {
      options[0].dropDownOptions = [];
      if (options[0].dropDownOptions.length === 0) {
        this.languageList = this.appConfig.i18n.languages;
        this.languageList.forEach((item: any) => {
          options[0].dropDownOptions.push({
            value: item,
            label: this.translate.instant('generics.languages.' + item),
            translatedLabel: this.translate.instant('generics.languages.' + item)
          });
        });
      }
    }
  }

  getDefaultValue(control: string, defaultValue?: any) {
    return this.parsedSettings && this.parsedSettings[control] ? this.parsedSettings[control] : defaultValue ? defaultValue : null;
  }

  saveValues(event: any, formControl: string) {
    if (!this.finishLoading) {
      return;
    }

    if (this.parsedSettings) {
      this.parsedSettings[formControl] = event;
    }
    this.sharedSettingsService.set(this.parsedSettings);
    this.getEnvironmentLanguages();
  }
}
